// Checkout link builder.
// Real checkout & payment is handled by the separate site: app.cdlacademy.com
//
// This mirrors the EXACT logic from the live cdlacademy.com Wix (Velo) code:
//   wixLocation.to('https://app.cdlacademy.com/dc?values=' + queryString)
// where queryString is a comma-separated list of numeric product ids,
// base course first, then endorsements in the order Hazmat, Passenger, School.
//
// Product id mapping (from the live site):
//   ClassA -> 100172 | ClassB -> 100174 | Upgrade -> 100173
//   Hazmat -> 100175 | Passenger -> 100176 | School -> 100177

export const CHECKOUT_BASE_URL = "https://app.cdlacademy.com/dc";

// Internal course id -> numeric product id used by app.cdlacademy.com
export const PRODUCT_ID_MAP = {
  // Step 1 - base courses (radio)
  "class-a": "100172",
  "class-b": "100174",
  "class-b-to-a": "100173",
  // Step 2 - endorsements (checkboxes)
  hazmat: "100175",
  passenger: "100176",
  "school-bus": "100177",
};

// Base courses first, then endorsements in the exact order the live site uses.
const CHECKOUT_ORDER = [
  "class-a",
  "class-b",
  "class-b-to-a",
  "hazmat",
  "passenger",
  "school-bus",
];

const BASE_IDS = ["class-a", "class-b", "class-b-to-a"];

/**
 * Build the external checkout URL from selected internal course ids.
 * Produces e.g. https://app.cdlacademy.com/dc?values=100172,100175
 *
 * @param {string[]} courseIds - e.g. ["class-a", "hazmat"]
 * @returns {string} full checkout URL (empty-safe)
 */
export function buildCheckoutUrl(courseIds = []) {
  const selected = new Set(courseIds.filter(Boolean));

  const values = CHECKOUT_ORDER.filter((id) => selected.has(id))
    .map((id) => PRODUCT_ID_MAP[id])
    .filter(Boolean);

  const queryString = values.join(",");
  if (!queryString) return CHECKOUT_BASE_URL;
  return `${CHECKOUT_BASE_URL}?values=${queryString}`;
}

/** Whether the given selection contains a valid step-1 base course. */
export function hasBaseCourse(courseIds = []) {
  return courseIds.some((id) => BASE_IDS.includes(id));
}

/** Redirect the browser to the external checkout site. */
export function goToCheckout(courseIds = []) {
  window.location.href = buildCheckoutUrl(courseIds);
}
